import request from '@/utils/request'

//获取个人中心信息
export function getUserSource() {
  return request({
    method: 'get',
    url: '/organization/api/info/user'
  })
}
//修改密码
export function updatePassWd(data) {
  return request({
    url: '/organization/api/info/update/passWd',
    method: 'post',
    data:data
  })
}
//上传头像
export function updateAvatar(data) {
  return request({
    url: '/organization/api/info/update/avatar',
    method: 'post',
    data:data
  })
}
//旧手机号验证码
export function getOldYzm(data) {
  return request({
    url: '/organization/api/info/old/sms',
    method: 'post',
    data:data
  })
}
//新手机号验证码
export function getNewYzm(data) {
  return request({
    url: '/organization/api/info/new/sms',
    method: 'post',
    data:data
  })
}
//修改手机号
export function updatePhone(data) {
  return request({
    url: '/organization/api/info/update/phone',
    method: 'put',
    data:data
  })
}
//修改信息
export function updateInfo(data) {
  return request({
    url: '/organization/api/info/update/info',
    method: 'put',
    data:data
  })
}
